import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/client';

// Richiesta del link per reimpostare la password. La risposta è sempre la stessa,
// esista o no l'account (il server non rivela chi è registrato).
export default function PasswordDimenticata() {
  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try { const r = await api.post('/auth/password-dimenticata', { email: email.trim() }); setMsg(r.data.message); }
    catch (err) { setError(err.response?.data?.error || 'Errore, riprova tra poco'); }
    finally { setLoading(false); }
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.logo}>B-CHEERS ASD</div>
        <div style={s.sub}>PASSWORD DIMENTICATA</div>
        {msg ? (
          <div style={s.ok}>{msg}</div>
        ) : (
          <>
            <p style={s.desc}>Scrivi l'email del tuo account: ti mandiamo un link per scegliere una nuova password.</p>
            <form onSubmit={handleSubmit} style={s.form}>
              <div style={s.field}>
                <label style={s.label}>EMAIL</label>
                <input style={s.input} type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="mario@email.it"
                  autoComplete="email" autoCapitalize="none" autoCorrect="off" spellCheck="false" required />
              </div>
              {error && <div style={s.error}>{error}</div>}
              <button type="submit" style={{ ...s.btn, opacity: loading ? 0.7 : 1 }} disabled={loading}>
                {loading ? 'INVIO...' : 'MANDAMI IL LINK'}
              </button>
            </form>
          </>
        )}
        <div style={s.footer}><Link to="/login" style={s.link}>Torna al login</Link></div>
      </div>
    </div>
  );
}

const s = {
  page:   { minHeight:'100vh', background:'var(--bg)', display:'flex', alignItems:'center', justifyContent:'center', padding:'20px' },
  card:   { background:'var(--bg)', border:'1px solid var(--border)', borderRadius:'16px', padding:'48px 40px', width:'100%', maxWidth:'400px' },
  logo:   { fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-title)', fontWeight:'800', color:'#F4600C', letterSpacing:'3px', textAlign:'center', marginBottom:'4px' },
  sub:    { fontSize:'var(--font-size-xs)', fontWeight:'700', color:'var(--text-dim)', letterSpacing:'2px', textAlign:'center', marginBottom:'24px' },
  desc:   { color:'var(--text-dim)', fontSize:'var(--font-size-sm)', marginBottom:'24px', lineHeight:'1.6', textAlign:'center' },
  form:   { display:'flex', flexDirection:'column', gap:'16px' },
  field:  { display:'flex', flexDirection:'column', gap:'7px' },
  label:  { fontSize: 'var(--font-size-xs)', letterSpacing:'2px', fontWeight:'700', color:'var(--text-dim)' },
  input:  { background:'var(--bg-input)', border:'1px solid var(--border2)', borderRadius:'10px', padding:'12px 14px', color:'var(--text)', fontSize:'var(--font-size-sm)', outline:'none', width:'100%', boxSizing:'border-box' },
  error:  { background:'#EF444420', border:'1px solid #EF444440', borderRadius:'8px', padding:'10px 14px', color:'#EF4444', fontSize:'var(--font-size-sm)', fontWeight:'600' },
  ok:     { background:'#22c55e20', border:'1px solid #22c55e40', borderRadius:'8px', padding:'10px 14px', color:'#22c55e', fontSize:'var(--font-size-sm)', fontWeight:'600' },
  btn:    { background:'#F4600C', color:'#fff', border:'none', borderRadius:'10px', padding:'14px', fontSize:'var(--font-size-sm)', fontWeight:'700', cursor:'pointer', letterSpacing:'1px', marginTop:'4px' },
  footer: { textAlign:'center', marginTop:'20px', fontSize:'var(--font-size-sm)', color:'var(--text-dim)' },
  link:   { color:'#F4600C', textDecoration:'none', fontWeight:'700' },
};
